module.exports = __webpack_public_path__ + "img/collaborate_37.54d299f5.jpg";